export default (args: {setDisplayedUnsubscribedShortlist: Function}) => (unregisteredCandidacyId: string) => {

  return args.setDisplayedUnsubscribedShortlist((ps: any[]) => ps.filter((item: any) => item._id !== unregisteredCandidacyId));
}